import { exists } from '@/api'
import dayjs from 'dayjs'

export interface BatchStatisticsReserveBestConditionListItem {
  reserveDateFrom: string
  reserveDateTo: string
  isSearchBooks: boolean
  isSearchAV: boolean
  isSearchMagazine: boolean
  orderLimit: string
  isStatisticsBranch: boolean
  isStatisticsMaterialFormat: boolean
  isStatisticsBunruiType: boolean
  branch: string
  materialFormat: string
  bunruiDigits: string
  memo: string
  batchType: string
}

export function BatchStatisticsReserveBestConditionListItemFromJSON(
  json: any
): BatchStatisticsReserveBestConditionListItem {
  const resp = JSON.parse(json)

  return {
    reserveDateFrom: exists(resp, 'reserve_date_from')
      ? resp.reserve_date_from
      : dayjs()
          .add(-1, 'month')
          .format('YYYYMMDD'),
    reserveDateTo: exists(resp, 'reserve_date_to')
      ? resp.reserve_date_to
      : dayjs().format('YYYYMMDD'),
    isSearchBooks: exists(resp, 'is_search_books')
      ? resp.is_search_books
      : false,
    isSearchAV: exists(resp, 'is_search_av') ? resp.is_search_av : false,
    isSearchMagazine: exists(resp, 'is_search_magazine')
      ? resp.is_search_magazine
      : false,
    orderLimit: exists(resp, 'order_limit') ? resp.order_limit : '',
    isStatisticsBranch: exists(resp, 'is_statistics_branch')
      ? resp.is_statistics_branch
      : false,
    isStatisticsMaterialFormat: exists(resp, 'is_statistics_material_format')
      ? resp.is_statistics_material_format
      : false,
    isStatisticsBunruiType: exists(resp, 'is_statistics_bunrui_type')
      ? resp.is_statistics_bunrui_type
      : false,
    branch: exists(resp, 'branch') ? resp.branch : '',
    materialFormat: exists(resp, 'material_format') ? resp.material_format : '',
    bunruiDigits: exists(resp, 'bunrui_digits') ? resp.bunrui_digits : '',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
